import React from 'react';
import { Home, ChevronRight } from 'lucide-react';

const PageHeader = ({ title, subtitle, breadcrumbs }) => {
  return (
    <section 
      className="relative bg-cover bg-center bg-no-repeat py-16 md:py-20"
      style={{ 
        backgroundImage: "url('/assets/images/asfischolar.jpg')",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      {/* Content container */}
      <div className="relative container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto text-center">
          
          {/* Breadcrumb navigation */}
          <div className="flex items-center justify-center gap-2 text-sm mb-6">
            <a 
              href="/" 
              className="text-gray-300 hover:text-white transition-colors flex items-center gap-1"
            >
              <Home size={14} />
              Home
            </a>
            <span className="text-gray-400 text-xs">&gt;&gt;&gt;</span>
            <span className="text-[#80078b] font-medium">Preview Issue</span>
          </div>
          
          {/* Main title */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Preview Issue
          </h1>
          
          {/* Subtitle/description */}
          <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto">
            Preview Issue
          </p>
          
        </div>
      </div>
    </section>
  );
};

export default PageHeader;